import axiosIns from '@/libs/axios';

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    getKareInfinaAccounts() {
      return new Promise((resolve, reject) => {
        axiosIns
          .get('getKareInfinaAccounts')
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },

    getKareInfinaReportData(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post('getKareInfinaReportData', queryParams)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },

    downloadKareInfinaReportXlsx(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post('downloadKareInfinaReportXlsx', queryParams, { responseType: 'blob' })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },

    getKareTickerMappings() {
      return new Promise((resolve, reject) => {
        axiosIns
          .get('getKareTickerMappings')
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },

    uploadKareTickerMappings(ctx, payload) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post('uploadKareTickerMappings', payload)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
  },
};
